module.exports = __webpack_public_path__ + "static/media/5import-8.cc259002.xlsx";